module.exports = ".appbar {\n  box-shadow: none;\n}\n\n.toolbar {\n  display: flex;\n  justify-content: flex-end;\n}\n"